import React, { ReactElement } from 'react'

import { FieldPrefix } from '../../../../1stlog-ui/src/components/Field'
import { useFieldArray } from '../../../../1stlog-ui/src/components/FieldArray'
import { TOrderEntryShipmentService } from '../../../../shipmetrics-shared/containers/OrderEntry/AdditionalServices/types'
import ShipmentService from '../../../../shipmetrics-shared/containers/OrderEntry/Form/Shipment/ShipmentServices/ShipmentService'

const ShipmentServices = (): ReactElement => {
  const { fields } =
    useFieldArray<TOrderEntryShipmentService>('shipmentServices')

  return (
    <>
      <h4 className="mt-0">
        {i18n.t('additional_services2', 'Zusatzservices')}
      </h4>
      {fields.map((name: string) => (
        <FieldPrefix prefix={name} key={name} overwritePrefix>
          <ShipmentService readonly />
        </FieldPrefix>
      ))}
    </>
  )
}

export default ShipmentServices
